import { ChangeDetectionStrategy, Component, computed, input, inject } from '@angular/core';
import { ImageScaleBreakpointService } from '../../../image-scale-breakpoint.service';
import { GameServer } from '../../../model/gameserver';
import { NgClass, NgOptimizedImage, TitleCasePipe } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { CardNavItem, CardShellComponent } from '../card-shell/card-shell.component';
import { ANGULAR_BREAKPOINTS } from '../../../image-breakpoints';
import { GameTitlePipe } from '../../../model/game-title.pipe';

@Component({
  selector: 'app-server[server]',
  imports: [NgClass, NgOptimizedImage, NgbTooltip, TitleCasePipe, CardShellComponent, GameTitlePipe],
  templateUrl: './server.component.html',
  styleUrl: './server.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServerComponent {
  private readonly imageScaleBreakPointService = inject(ImageScaleBreakpointService);

  public readonly server = input.required<GameServer>();

  protected readonly navItems = computed(() => {
    const s = this.server();
    const items: CardNavItem[] = [];
    if (s.urls?.game) {
      items.push({ href: s.urls.game, icon: this.getGameUrlIcon(s.urls.game), tooltip: 'Game Store Page' });
    }
    if (s.urls?.map) {
      items.push({ href: s.urls.map, icon: 'mdi:map', tooltip: 'Map' });
    }
    return items;
  });

  protected readonly topImageSizes = this.imageScaleBreakPointService.generateBootstrapBreakpoints({
    xs: 'calc(100vw -24px)',
    sm: '10rem',
    md: '13.5rem',
    lg: '18.5rem',
    xl: '17rem',
    xxl: '20rem',
  });

  protected avifSrcset(basePath: string): string {
    return ANGULAR_BREAKPOINTS.map(w => `${basePath}.${w}px.avif ${w}w`).join(', ');
  }

  private getGameUrlIcon(url: string): string {
    const parsed = new URL(url);
    switch (parsed.host) {
      case 'store.steampowered.com':
        return 'custom:steam';
      default:
        return 'mdi:link-variant';
    }
  }
}
